<template>
  <div class="header-title" :class="{ nopad: noSpacing }">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    title: { type: String, default: '' },
    noSpacing: { type: Boolean, default: false },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
